<template>
    <tr>
        <td>{{article.content_by_lang.title}}</td>
        <td>{{article.rubric_id}}</td>
        <td>{{article.languages}}</td>
        <td>{{article.content_by_lang.status}}</td>
        <td>
            <button
                    @click="$emit('delete-article', {rubric_id: article.rubric_id, article_id: article.id})"
                    type="button" class="btn btn-danger btn-sm"
            >Del</button>
            <button
                    @click="$emit('edit-article', {rubric_id: article.rubric_id, article_id: article.id})"
                    type="button" class="btn btn-primary btn-sm"
            >Edit</button>
            <a
                    :href="`article?r=${article.rubric_id}&a=${article.id}&preview`"
                    class="btn btn-light btn-sm"
                    target="_blank"
            >Prew</a>
        </td>
    </tr>
</template>

<script>
    export default {
        props: {
            article: { type: Object, required: true }
        },
        emits: ['delete-article', 'edit-article'],
        setup() {}
    }
</script>

<style scoped>

</style>